import React, { Component } from "react";

export class AddProcess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            processId: parseInt(window.location.href.substring(window.location.href.lastIndexOf('/') + 1)),
            process: {},
            loadingPage: false, showState: null,
            required: {
                description: false,
                processNumber: false,
                city: false,
                process: false,
                description: false,
            },
            isPost: false
        }
    }

    async getProcessById() {
        this.setState({ loadingPage: true });
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
        }

        const response = await fetch(`Process/GetProcessById?processId=${this.state.processId}`, request);
        const data = await response.json();
        this.setState({ loadingPage: false });

        if (response.redirected) {
            window.location.href = response.url;
        }

        if (data) {
            this.setState({ process: data });
        }
    }

    componentDidMount() {
        if (this.state.processId) {
            this.getProcessById();
        }
    }

    async saveProcessInfo() {

        this.setState({ isPost: true });
        if (Object.values(this.state.required).find((a) => { return !a }) == undefined) {
            if (!document.querySelector('#descriptionProcess').value) {
                alert("El campo descripción es obligatorio.");
                return false;
            }

            this.setState({ loadingPage: true, success: '' });

            const model = {
                Id: this.state.process.id,
                Description: document.querySelector('#descriptionProcess').value,
                Type: document.querySelector('#typeProcess').value,
                Show: document.querySelector('#chkShow').checked,
                City: document.querySelector('#City').value,
                ProcessNumber: document.querySelector('#processNumber').value
            };

            const request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(model)
            }

            const response = await fetch('Process/SaveProcessInfo', request);

            if (response.status == 200) {
                this.setState({ loadingPage: false });
                alert('Información guardada con éxito');
                window.location.href = '/administrar-procesos'
            }
        }
    }

    render() {

            this.state.required.description = Boolean(this.state.process.description);
            this.state.required.processNumber = Boolean(this.state.process.processNumber);
            this.state.required.city = Boolean(this.state.process.city);
            this.state.required.process = Boolean(this.state.process.type);
        
        return (
                        <div>

                            <div className="modal-body add-process">
                                <div className="table">

                        <div className="group-control">
                            <h2>Agregar o editar proceso</h2>
                        </div>

                                    <div className="group-control mt-5">
                            <label>Descripci&oacute;n</label>
                            <input type="text" id="descriptionProcess" className="form-control" maxLength="100" defaultValue={this.state.process.description} onChange={(e) => {
                                            this.state.required.description = Boolean(e.currentTarget.value);
                                        }} />
                                        {!this.state.required.description && this.state.isPost ? <span className="error">Campo requerido</span> : null}
                                    </div>

                                    <div className="group-control mt-3">
                            <label>N&uacute;mero de proceso</label>
                            <input type="text" id="processNumber" className="form-control" maxLength="10" defaultValue={this.state.process.processNumber} onChange= {(e) => {
                                this.state.required.processNumber = Boolean(e.currentTarget.value);
                            }} />
                                        {!this.state.required.processNumber && this.state.isPost ? <span className="error">Campo requerido</span> : null}
                                    </div>

                                    <div className="group-control mt-3">
                            <label>Ciudad</label>
                            <select className="form-control" id="City" onChange={(e) => {
                                            this.state.required.city = Boolean(e.currentTarget.value);
                            }}>
                                <option value="">Seleccione</option>
                                <option value="Medellín" selected={this.state.process.city == 'Medellín'}>Medell&iacute;n</option>
                                <option value="Rionegro" selected={this.state.process.city == 'Rionegro'}>Rionegro</option>
                                <option value="Bogotá" selected={this.state.process.city == 'Bogotá'}>Bogotá</option>
                                        </select>
                                        {!this.state.required.city && this.state.isPost ? <span className="error">Campo requerido</span> : null}
                                    </div>

                                    <div className="group-control mt-3">
                                        <label>Proceso</label>
                                        <select className="form-control" id="typeProcess" onChange={(e) => {
                                            this.state.required.process = Boolean(e.currentTarget.value);
                                        }}>
                                <option value="">Seleccione</option>
                                <option value="Basic" selected={this.state.process.type == 'Basic'}>Básico</option>
                                <option value="Advance" selected={this.state.process.type == 'Advance'}>Avanzado</option>
                                <option value="PL" selected={this.state.process.type == 'PL'}>Programa de liderazgo</option>
                                        </select>
                                        {!this.state.required.process && this.state.isPost ? <span className="error">Campo requerido</span> : null}
                                    </div>

                                    <div className="group-control mt-3">
                            {this.state.process.show ?
                                <input type="checkbox" id="chkShow" defaultChecked /> :
                                        <input type="checkbox" id="chkShow" /> }
                                        <label>Visible </label>
                                    </div>

                        <div className="group-control mt-3">
                            
                            {this.state.loadingPage ? <span className="btn btn-cancel">Procesando...</span> : <input type="button" className="btn btn-primary" value="Guardar" onClick={(event) => { this.saveProcessInfo() }} />}
                            <a href="/administrar-procesos" className="btn btn-secondary">Volver</a>
                                    </div>

                                    <div className="group-control">
                                        <span className={this.state.success && this.state.success.indexOf('Error') != -1 ? 'error' : 'success'}>{this.state.success}</span>
                                    </div>

                                </div>
                            </div>
            </div >
        )
    }
}